module.exports = {
    apiProject: "https://66a6902023b29e17a1a2fcaa.mockapi.io/projects",
    apiInterest:
        "https://backend-info-ducthanh-2.onrender.com/saying/get-all-saying",
};
